import { coBrandingEnabled, customLogoUrl } from '@/utils/constants';
import { cn } from '@/utils/tailwind';

import LogoBlack from './LogoBlack.svg?react';
import LogoBlackLarge from './LogoBlackLarge.svg?react';

const _SIZE_MAP = {
  xs: 'h-4 w-auto',
  sm: 'h-5 w-auto',
  md: 'h-5 w-[120px]',
  lg: 'h-6 w-[162px]',
  xl: 'h-[38px] w-[233px]',
  default: 'h-6 w-[48px]',
} as const;

export function Logo(props: {
  size?: keyof typeof _SIZE_MAP;
  className?: string;
}) {
  if (customLogoUrl) {
    // If co-branding is enabled (default true), show both logos
    if (coBrandingEnabled) {
      return (
        <div className="flex items-center gap-2">
          <img
            src={customLogoUrl}
            alt="Custom Logo"
            className={cn('h-4 w-auto', props.className)}
            style={{ objectFit: 'contain' }}
          />
          <span className="text-sm font-light text-gray-400">+</span>
          <LogoBlackLarge className={cn('h-4 w-auto', props.className)} />
        </div>
      );
    }

    // If co-branding is disabled, show only custom logo
    return (
      <img
        src={customLogoUrl}
        alt="Custom Logo"
        className={cn('h-4 w-auto', props.className)}
        style={{ objectFit: 'contain' }}
      />
    );
  }

  // Fallback to default LangSmith logos
  if (props.size === 'xl') {
    return (
      <LogoBlackLarge className={cn('h-[38px] w-[233px]', props.className)} />
    );
  }
  if (props.size === 'lg') {
    return <LogoBlackLarge className={cn('h-6 w-[162px]', props.className)} />;
  }
  if (props.size === 'md') {
    return <LogoBlackLarge className={cn('h-5 w-[120px]', props.className)} />;
  }
  if (props.size === 'xs') {
    return <LogoBlack className={cn('w-[30px]', props.className)} />;
  }
  return <LogoBlack className={cn('h-6 w-[48px]', props.className)} />;
}
